"use client";

import { useCallback, useEffect } from "react";

const HeaderStyle = () => {
  const handleScroll = useCallback((e) => {
    const window = e.currentTarget;
    if (window.pageYOffset > 100) {
      document
        .querySelector(".jlt-reactadmin header #container > div > a")
        .removeAttribute("style");

      const imgElement = document.querySelectorAll(
        ".jlt-reactadmin header #container > div > a img"
      );
      if (imgElement) {
        imgElement.forEach((img) => {
          img.removeAttribute("style");
        });
      }

      document.querySelectorAll(".jlt-reactadmin header nav > ul > li > a").forEach((anchor) => {
        anchor.removeAttribute("style");
      });

      document.querySelectorAll(".jlt-reactadmin header nav ul li a span svg").forEach((svg) => {
        svg.removeAttribute("style");
      });
    } else {
      handleStyle();
    }
  }, []);

  const handleStyle = () => {
    document.querySelector(".jlt-reactadmin header #container > div > a").style.cssText = `
        background-image: url('/light-logo.svg');
        background-repeat: no-repeat;
        width: 224px;
        height: 28px;
      `;

    const imgElement = document.querySelectorAll(".jlt-reactadmin header #container > div > a img");
    if (imgElement) {
      imgElement.forEach((img) => {
        img.style.display = "none";
      });
    }

    document.querySelectorAll(".jlt-reactadmin header nav > ul > li > a").forEach((anchor) => {
      anchor.style.color = "#fff";
    });

    document.querySelectorAll(".jlt-reactadmin header nav > ul > li > a").forEach((anchor) => {
      anchor.addEventListener("mouseover", () => {
        anchor.style.color = "var(--primary)";
      });
      anchor.addEventListener("mouseout", () => {
        anchor.style.color = "#fff";
      });
    });

    document
      .querySelectorAll(".jlt-reactadmin header nav > ul > li > a span svg")
      .forEach((svg) => {
        svg.style.fill = "#fff";
      });
  };

  useEffect(() => {
    handleStyle();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return null;
};

export default HeaderStyle;
